module.exports = __webpack_public_path__ + "img/15.5044ddbc.png";